import type { CellContext } from '@/components/ui/table/types'
import type { Document } from '@/modules/documents'

export const NumberOfPagesCell = (cell: CellContext<Document, string>) => (
  <div className="text-left">{cell.getValue()}</div>
)
